import React, { useState } from 'react';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { AuthForm } from '@/components/AuthForm';
import { Dashboard } from '@/components/Dashboard';
import { MembrePage } from '@/components/MembrePage';
import { AdminPanel } from '@/components/AdminPanel';
import { VirtualTeacherChat } from '@/components/VirtualTeacherChat';
import { FAQForum } from '@/components/FAQForum';
import { Navbar } from '@/components/Navbar';
import { Toaster } from '@/components/ui/toaster';

const AppContent: React.FC = () => {
  const { user, loading } = useAuth();
  const [currentPage, setCurrentPage] = useState<'dashboard' | 'membre' | 'admin' | 'chat' | 'faq'>('dashboard');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-yellow-50">
        <div className="text-center">
          <img 
            src="/images/IMG-20250728-WA0002.jpg" 
            alt="Sprintbac Logo" 
            className="h-16 w-auto mx-auto mb-4 logo-pulse"
          />
          <div className="animate-pulse text-muted-foreground">Chargement...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <AuthForm />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-yellow-50">
      <Navbar 
        currentPage={currentPage} 
        onNavigate={setCurrentPage}
      />
      {currentPage === 'dashboard' ? (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Dashboard />
        </main>
      ) : currentPage === 'membre' ? (
        <MembrePage />
      ) : currentPage === 'admin' ? (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <AdminPanel />
        </main>
      ) : currentPage === 'chat' ? (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <VirtualTeacherChat />
        </main>
      ) : currentPage === 'faq' ? (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <FAQForum />
        </main>
      ) : (
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Dashboard />
        </main>
      )}
    </div>
  );
};

const Index: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
      <Toaster />
    </AuthProvider>
  );
};

export default Index;
